<ul class="c-list-status-review list-unstyled">
  <li class="c-list-status-review__item">
    <span
      class="c-list-status-review__label label"
      i18n="@@listStatusReview-label"
      >In Review</span
    >
  </li>
  <li class="c-list-status-review__item">
    <span
      class="c-list-status-review__description"
      i18n="@@listStatusReview-description"
    >
      The library will review the list and then publish.
    </span>
  </li>
</ul>
